export const POPUP_PARENT_IDS_ATTRIBUTE = 'data-parent-ids'
export const POPUP_PARENT_IDS_SPLITTER = '_'

export const HOVER_DELAY = 100

export const FIXED_CLASS = 'context-fixed' // declare in base.scss
